const HOME = 'home'

const ABOUT = 'about'

const NEWS = 'news'

const Developer = 'developer'

const MINER = 'miner'

const PARTNER = 'partner'

const Solution = 'solution'

const NCdn = 'ncdn'

const NSwitchboard = 'dataride'

export default {
  HOME, ABOUT, NEWS, Developer, MINER, PARTNER, Solution, NCdn, NSwitchboard
}



// WEBPACK FOOTER //
// ./src/assets/js/nknNamespace.js